import React from 'react';
import InputMask from 'react-input-mask';

class MaskedBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
		};
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {		
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	flag = (status) => {
		if (!status)
			this._input.classList.add('invalid-field');
		else
			this._input.classList.remove('invalid-field');
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	_handleInputBlur = (e) => {
		this._update(e.target.value);
		this.props.onBlur && this.props.onBlur();
	}

	// Private

	_handleInputKeyDown = (e) => {
		this.onDirt();
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_update = (value) => {
		const me = this;

		this.setState({ value }, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);
			const status = requiredPassed && validationPassed;
	
			// Show error status if neccesary
			this.flag(status);
	
			if (this.props.valueBuilder)  {
				value = this.props.valueBuilder(value);
			}

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
			else
				// If not, only trigger this comp change
				this.onChange(value);
		});
	}

	_handleInputChange = (e) => {
		this._update(e.target.value);
	}

	_handleInputFocus = (e) => {
		this.props.onFocus && this.props.onFocus();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.state.disabled
			|| nextState.value !== this.state.value);
	}

	componentDidUpdate = (_, prevState) => {
		if (prevState.value === this.state.value && this.props.value !== this.state.value)
			this.setState({ value: this.props.value });
	}

	render() {

		let opts = {
			id: this.props.id,
			name: this.props.name,
			value: this.state.value || "",
			placeholder: this.props.placeholder,
			style: this.props.style,
			autoComplete: "off",
			className: "form-control " + this._className(),
			disabled: this.props.disabled ? "disabled" : undefined,
			onFocus: this._handleInputFocus,
			onChange: this._handleInputChange,
			onBlur: this._handleInputBlur,
			alwaysShowMask: this.props.alwaysShowMask,
			onKeyDown: this._handleInputKeyDown,
			maskChar: this.props.maskChar,
			mask: this.props.mask
		};

		return <InputMask {...opts} inputRef={(input) => this._input = input} />;
	}
}

export default MaskedBox;

// Mark this as a form component
MaskedBox.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/maskedBox/MaskedBox.js